import React, { useState } from 'react';
import { Link, a } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import Sidebar from '../../../../components/Sidebar/Sidebar';

const HomeThreeNavBar = () => {
   const [show, setShow] = useState(false);

   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);
   const [sticky, setSticky] = useState(false);
   const stickyNavbar = () => {
      if (window.scrollY > 0) {
         setSticky(true)
      }
      else {
         setSticky(false)
      }
   }
   window.addEventListener('scroll', stickyNavbar);
   return (
      <>
         <header>
            <div className={sticky ? "sticky-menu tp-header-area-three header-sticky" : "tp-header-area-three header-sticky"}>
               <div className="tp-custom-container">
                  <div className="row justify-content-xl-center align-items-center">
                     <div className="col-xxl-2 col-xl-2 col-8">
                        <div className="tp-header-logo-three">
                           {/*<Link to="/">
                              <img src="assets/img/logo/logo_new.svg" className="img-fluid" alt="logo not found" />
                           </Link>*/}
                           <a target="_blank" href="https://www.neogrowth.in/"><img src="assets/img/logo/logo_new.svg" className="img-fluid" alt="logo not found" /></a>
                        </div>
                     </div>
                     <div className="col-xxl-8 col-xl-8 col-4">
                        <div className="tp-main-menu tp-main-menu-three">
                        <nav id="tp-mobile-menu">
                           <ul>
                              <li className="menu-item-has-children">
                                 <a href="/">About Us</a>
                                 <ul className="sub-menu">                                    
                                    <li><a target="_blank" href="https://www.neogrowth.in/about-us/" >Our Story</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/board-of-directors/">Board Of Directors</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/partner-2/">Our Partners</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/leadership-team/">Leadership Team</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/awards-recognitions/">Awards &#038; Recognitions</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/corporate-brochure/">Corporate Brochure</a></li>
                                 </ul>
                              </li>
                              <li className="menu-item-has-children">
                                 <a href="/">Investor Relations</a>
                                 <ul className="sub-menu">
                                    <li><a target="_blank" href="https://www.neogrowth.in/annual-report/">Annual Report</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/annual-return/">Annual Return</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/financial-results/">Financial Results</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/stock-exchange-intimation/">Stock Exchange Intimation</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/rbi-disclosures/">RBI Disclosures</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/company-policies/">Company Policies</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/consumer-education/">Consumer Education</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/msme-insight-report-2022/">MSME Insight Report 2022</a></li>
                                 </ul>
                              </li>
                              <li className="menu-item-has-children">
                                 <a href="/">Products </a>
                                 <ul className="sub-menu">
                                    <li><a target="_blank" href="https://www.neogrowth.in/products/">Retail Finance</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/products/">Supply Chain Finance</a></li>
                                 </ul>
                              </li>
                              <li className="menu-item-has-children">
                                 <a href="/">Social Impact</a>
                                 <ul className="sub-menu">
                                    <li><a target="_blank" href="https://www.neogrowth.in/social-impact/">Social Impact</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/client-stories/">Client Stories</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/sanjivni/">Sanjivni</a></li>
                                 </ul>
                              </li>
                              <li className="menu-item-has-children">
                                 <a href="/">DiGibizz</a>
                                 <ul className="sub-menu">
                                    <li><a target="_blank" href="https://digibizz.neogrowth.in/knowStatus">Know Your Digital Status</a></li>
                                    <li><a target="_blank" href="https://digibizz.neogrowth.in/services">Explore Services</a></li>
                                    <li><a target="_blank" href="https://digibizz.neogrowth.in/knowledgeCenter">Knowledge Center</a></li>
                                    <li><a target="_blank" href="https://digibizz.neogrowth.in/successStories">Success Stories</a></li>
                                 </ul>
                              </li>
                              <li className="menu-item-has-children">
                                 <a href="/">Customer Services</a>
                                 <ul className="sub-menu">
                                    <li><a target="_blank" href="https://elogin.neogrowth.in/login?service=https%3A%2F%2Fmy.neogrowth.in%2F">Login</a></li>
                                    <li><a target="_blank" rel="noopener" href="https://www.neogrowth.in/faq-ex-gratia-scheme.pdf">FAQ’s Ex-Gratia Scheme</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/customer-services/">Customer Support</a></li>
                                    <li><a target="_blank" href="https://www.neogrowth.in/faq/">FAQ</a></li>
                                    <li><a target="_blank" href="mailto:digital@neogrowth.in">Partner with Us</a></li>
                                 </ul>
                              </li>
                           </ul>
                        </nav>
                        </div>
                        {/* <!-- mobile menu activation --> */}
                        <div className="side-menu-icon d-xl-none text-end">
                           <button onClick={handleShow} className="side-toggle border-0 bg-transparent">
                              <i> <FaBars className='bar_icon' /> </i></button>
                        </div>
                     </div>
                     <div className="col-xxl-2 col-xl-2 d-none d-xl-block">
                        <div className="tp-header-right-three">
                           {/* <div className="tp-header-number-three">
                              <span>Call Us : <a href="tel:33888200-55">33 888 200 - 55</a></span>
                           </div> */}
                           <div className="tp-header-btn-three">
                              <a target="_blank" href="https://www.neogrowth.in/loan-details/" className="yellow-btn" style={{borderRadius:"10px"}}>
                                 <i className="flaticon-enter"></i> Apply Now</a>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </header>

         <Sidebar show={show} handleClose={handleClose}></Sidebar>
      </>
   );
};

export default HomeThreeNavBar;